import DetailsPageLowerLayer from "../../../Components/DetailsPageLowerLayer/DetailsPageLowerLayer";
import Toolbar from "../../../CommonComponents/common/Toolbar";
import { Box } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import TopSection from "../../../CommonComponents/TopSection";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useMemo, useEffect } from "react";
import CollapsibleHeader from "../../../CommonComponents/common/CollapsibleHeader";
import useRedirect from "../../../CustomHooks/useRedirect";
import { fetchHeaderAndLinesData } from "../../../services/InboundDeliveries/InboundDeliveryDetail";
import InboundDeliveryHeader from "./InboundDeliveryHeader";
import SectionSpinner from "../../../CommonComponents/common/Loader/SectionSpinner";
import { formatValue } from "../../../utils/currencyUtils";


const normalizePoOrderType = (value = "") => {
  return decodeURIComponent(value)
    .toLowerCase()
    .split(/\s+/)
    .map((word, index) => {
      if (word === "po") return "PO"; 
      if (index === 0) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join("");
};

const InboundDeliveryDetail = () => {
  const redirect = useRedirect();
  const navigate = useNavigate();
  let { id } = useParams();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [data, setData] = useState({});
  const [deliveryLinesRows, setdeliveryLinesRows] = useState([]);
  const [exceptionType, setExceptionType] = useState("");
  // Separate loading states for each section
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [loadingLines, setLoadingLines] = useState(false);

  const breadcrumbArray = [
    "Supply",
    "Inbound Deliveries",
    "Inbound Deliveries Detail",
  ];

  useEffect(() => {
    // Define an async function to make the GET request
    const formatHeaderAndLinesData = async () => {
      setLoadingDetails(true);
      setLoadingLines(true);

      setLoadingDetails(true);
      setLoadingLines(true);

      const data = await fetchHeaderAndLinesData(id);
      if (data.error) {
        setData([]); 
        setLoadingDetails(false);
    };
      setData(data);
      setExceptionType(data?.exceptionType);
      setLoadingDetails(false);

      const formattedLinesRows = data?.deliveryLines?.map((item) => ({
        line_no: item.lineNo,
        line_state: item?.lineState,
        erp_line_state: item?.erpLineState,
        po_no: item?.poNo,
        po_line: item?.poLine,
        po_order_type: item?.poOrderType,
        po_customer: item?.poCustomer,
        po_supplier: item?.poSupplier,
        order_uom: item?.orderUOM,
        shipped_qty: formatValue(item?.shippedQuantity),
        item: item?.item,
        item_name: item?.itemName,
        customer_item_owner: item?.customerItemOwner,
        material_class: item?.materialClass,
        hazmat: item?.containsHazmat,
        temp_controlled: item?.tempControlled,
      }));
      setLoadingLines(false);
      setLoadingLines(false);
      setdeliveryLinesRows(formattedLinesRows);
    };
    formatHeaderAndLinesData();
  }, [id]);

  const redirectFn = useMemo(() => {
    return (path, state) => {
      redirect(path, state);
    };
  }, [redirect]);

  const toolbarProps = {
    number: id,
    status: exceptionType,
    icon: <ReceiptLongIcon />,
    onBack: () => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate("/core/supply/delivery");
      }
    },
    isCollapsed,
    toggleHeader: () => setIsCollapsed((prev) => !prev),
  };

  const linesTab = useMemo(() => ({
    label: `Delivery Lines (${deliveryLinesRows?.length ?? 0})`,
    loading: loadingLines,
    columns: [
      { field: "line_no", headerName: "Line No" },
      { field: "line_state", headerName: "Line State" },
      { field: "erp_line_state", headerName: "ERP Line State" },
      {
        field: "po_no",
        headerName: "PO No",
        cellRenderer: (params) => {
          const { value } = params;
          const redirect = params.colDef.cellRendererParams?.redirect;
          const poOrderTypeRaw = params.data?.po_order_type;
          const poOrderType = normalizePoOrderType(poOrderTypeRaw);
          
          return (
            <span
              onClick={() =>
                redirect( `/core/supply/order/order-detail/${poOrderType}/${value}`, {
                  menu: "Supply",
                  label: "Purchase Orders",
                  outerLabel: "Purchase Orders Detail",
                  previousPage: window.location.pathname,
                })
              }
              style={{
                color: "#1976d2",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              {value}
            </span>
          );
        },
        cellRendererParams: { redirect: redirectFn },
      },
      { field: "po_line", headerName: "PO Line" },
      { field: "po_order_type", headerName: "PO Order Type" },
      { field: "po_customer", headerName: "PO Customer" },
      { field: "po_supplier", headerName: "PO Supplier" },
      { field: "order_uom", headerName: "Order UOM" },
      { field: "shipped_qty", headerName: "Shipped Qty" },
      { field: "item", headerName: "Material Number" },
      { field: "item_name", headerName: "Material Description" },
      { field: "customer_item_owner", headerName: "Customer Item Owner" },
      { field: "material_class", headerName: "Material Class" },
      // { field: "hazmat", headerName: "Contains Hazmat" },
      // { field: "temp_controlled", headerName: "Temp Controlled" },
    ],
    rows: deliveryLinesRows,
  }), [loadingLines, deliveryLinesRows, redirectFn]);

  const tabs = [linesTab];

  return (
    <div>
      <TopSection
        breadcrumbArray={breadcrumbArray}
        hideHeader={true}
        headerName={""}
        hideTitle={true}
      />
      <Toolbar {...toolbarProps} />
      <CollapsibleHeader
        upperLayer={
          <Box sx={{ position: "relative" }}>
            {loadingDetails && <SectionSpinner />}<InboundDeliveryHeader hProps={data} />
          </Box>
        }
        lowerLayer={<DetailsPageLowerLayer tabs={tabs} />}
        isCollapsed={isCollapsed}
      />
    </div>
  );
};
export default InboundDeliveryDetail;
